export default "__VITE_ASSET__DUGOIKWA__"